<template>
  <div class="container flex" style="margin-bottom: 20px;margin-top: 15px;">
    <div>
      <left></left>
    </div>
    <div class="flex1" style="margin-left: 20px;">
        <right :title="title" :list="list" :questionsStatus="questionsStatus"></right>
    </div>

  </div>
</template>

<script>
  import left from './left.vue'
  import right from './examlist.vue'
  export default {
    name: 'Footer',
    components:{
      left,
      right
    },
    data () {
      return {
          data:'',
          title:'二二密训',
          pageNo:1,
          pageSize:100,
          questionsStatus:7,
          list:[]
      }
    },
    methods:{
      getData(){
        let data={
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          questionsStatus:this.questionsStatus,
        };
        this.$axios.get(this.$common.testPaper_exercisesList,{params:data}).then((res)=>{
              if(res.data.code==1){
                  this.list=res.data.data.list;
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created(){
      this.getData()
    }
  }
</script>

<style scoped="">
  .live {
    border-left: none;
    border-right: none;
    border-top: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/double.vue